import React, { useState } from "react";
import { IStatus } from "../../models/status.ts";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

interface StatusSelectProps {
  statuses: IStatus[];
  onSelectedStatusesChange: (selectedStatusIds: number[]) => void;
}

export const StatusSelect: React.FC<StatusSelectProps> = ({
  statuses,
  onSelectedStatusesChange,
}) => {
  const [selectedStatuses, setSelectedStatuses] = useState<number[]>();
  if (statuses && statuses.length > 0) {
    return (
      <FormControl fullWidth variant="outlined">
        <InputLabel>ステータス</InputLabel>
        <Select
          multiple
          value={selectedStatuses || []}
          onChange={(event) => {
            const selectedIds = event.target.value as number[];
            setSelectedStatuses(selectedIds);
            onSelectedStatusesChange(selectedIds);
          }}
          label="ステータス"
        >
          {statuses.map((status) => (
            <MenuItem key={status.id} value={status.id}>
              {status.agent_label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
};
